
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"
import HeroBannerGeneral from "@soenergy/frontend-library/src/components/HeroBannerGeneral"

export default {
  name: `BasicPage`,
  components: {
    ContentBlockList,
    HeroBannerGeneral
  },
  props: {
    content: {
      required: true,
      type: Object
    }
  },
  computed: {
    hero() {
      return this.content.hero[0]
    },
    bodyClasses() {
      const classes = ["basic-page__body"]

      if (this.content.pageColumns !== "is-12") {
        classes.push(`basic-page__body--padded`)
        classes.push(`container`)
      }

      if (this.content.noTopPadding) {
        classes.push(`basic-page__body--no-padding-top`)
      }

      if (this.content.noBottomPadding) {
        classes.push(`basic-page__body--no-padding-bottom`)
      }

      if (this.content.centered) {
        classes.push(`basic-page__body--centered`)
      }

      return classes
    },
    bodyInnerClass() {
      return "basic-page__body-inner column " + this.content.pageColumns
    }
  }
}
